import { ReactElement, useCallback } from 'react';
import {
  AuthenticationError,
  AxiosResult,
  AxiosResultDefaultError,
} from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import Loading from '../../../../../components/info/Loading';
import { getFormData } from '../../api';
import { WorkingDaysFiltersResponse } from '../../type';
import DisplayError from '../../../../../components/info/DisplayError';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  WorkingDaysFiltersResponse,
  AuthenticationError | AxiosResultDefaultError
>();

export function useWorkingDaysFilterLoader() {
  return useFetch();
}

export const WorkingDaysFilterLoaderConsumer = FetchConsumer;

export default function WorkingDaysFilterLoader({ children }: BaseLoaderProps) {
  const request = useCallback(async (): Promise<
    AxiosResult<WorkingDaysFiltersResponse, AxiosResultDefaultError>
  > => {
    return getFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading />;
          } else if (error) {
            return (
              <DisplayError typeError={error.code} retryAction={refresh} />
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
